import React, { forwardRef } from "react";
import { classNames } from "../utils/classNames";
import { useViewStyles } from "./View.styles";
export var View = forwardRef(function (props, contentRef) {
    var _a;
    var Element = (_a = props === null || props === void 0 ? void 0 : props.elementType) !== null && _a !== void 0 ? _a : "div";
    return (React.createElement(Element, { className: classNames(useViewStyles(props).view), ref: contentRef, role: props === null || props === void 0 ? void 0 : props.role }, props === null || props === void 0 ? void 0 : props.children));
});
